<template>
    <div class="storeList">
        <ServiceStoreItem
            class="discountServiceItem"
            v-for="item in list"
            :key="item.id"
            :item="item"
            @onClickItem="onGoToStoreHome(item)"
        />
    </div>
</template>

<script>
import ServiceStoreItem from '@/components/serviceStoreItem/serviceStoreItem'

export default {
    name: 'storeListComponent',
    components : {
        ServiceStoreItem
    },
    data () {
        return {
        }
    },
    computed: {
    },
    props: {
        /**
         * 列表数据源
         */
        list: {
            type: Array,
            required: true,
            default () {
                return []
            }
        },
    },
    methods: {
        /**
         * 跳转门店主页
         */
        onGoToStoreHome (item) {
            const { distribution_code } = this.$route.query
            this.$router.push({
                name: 'storeHome',
                query: {
                    distribution_code,
                    store_id: item.store_id,
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/stylus/variables.styl";
@import "~@/assets/stylus/mixin.styl";
</style>
